
<div>
  <label :for="$attrs.id" class="a-select-label" :class="{srOnly: srOnlyLabel}"><slot></slot></label>
  <a-select
    :id="$attrs.id"
    :options="options"
    :selectedOptionIds="completerIds"
    bind-by-object
    :multiselect="true"
    compress
    @input="createAssignee"
    @destroy="destroyAssignee"></a-select>

  <template v-for="permittee in permittees">
    <pill
        full
        :class="$attrs.id"
        :color="pillColor(permittee)"
        @onRemove="permittee.destroy()"
        :value="permittee.display"
    ></pill>
  </template>
</div>
